export default "__VITE_ASSET__CoN7UqZ$__"